<template>
  <Block class="activity-time">
    <img class="img" :src="img" />
  </Block>
</template>

<script setup lang="ts">
import Block from "./common/block.vue";
import useDevice from "./common/useDevice";

// const { isLargeScreen } = useDevice();

const isLargeScreen = ref(false);
const resize = () => {
  isLargeScreen.value = window.innerWidth >= 1360;
};
onMounted(() => {
  resize();
});
window.addEventListener("resize", resize);
window.addEventListener("orientationchange", resize);

onBeforeUnmount(() => {
  window.removeEventListener("resize", resize);
  window.removeEventListener("orientationchange", resize);
})

const img = computed(() =>
  isLargeScreen.value
    ? `https://p4-ky.wsukwai.com/kos/nlav12119/ijZrATES_2024-08-07-20-08-31.png`
    : `https://p4-ky.wsukwai.com/kos/nlav12119/dehPwVSS_2024-08-07-20-14-48.png`,
);
</script>

<style scoped lang="less">
.activity-time {

  :deep(.wrapper.card) {
    padding: 0;
    margin: 0 0.44rem;
  }

  @media screen and (max-width: 1360px) {
    margin-bottom: 0.56rem;

    :deep(.wrapper.card) {
      padding: 0;
      margin: 0 0.44rem;
    }
  }

  .img {
    width: 38.38rem;
    padding-bottom: 2rem;
    margin-top: -0.25rem;

    @media screen and (max-width: 1360px) {
      width: 100%;
      margin-top: 0rem;
      padding-bottom: 0rem;
    }
  }
}
</style>
